import Text from '@raydiant/raydial/components/Text';
import Button from '@raydiant/raydial/components/Button';
import { DialogTrigger } from '@raydiant/raydial/components/Dialog';
import Popover from '@raydiant/raydial/components/Popover';
import { Plus } from '../LocationsPage/Icons';

interface LibraryPageActionButtonProps {
  isOpen: boolean;
  onClick: (open: boolean) => void;
  onPresentationClick: () => void;
  onPlaylistClick: () => void;
  isDisabled?: boolean;
}

const LibraryPageActionButton = ({
  isOpen,
  onClick,
  onPresentationClick,
  onPlaylistClick,
  isDisabled,
}: LibraryPageActionButtonProps) => {
  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onClick}>
      <Button
        aria-label="add"
        variant="primary"
        className="bg-blue-600 disabled:bg-gray-600"
        onPress={() => onClick(!isOpen)}
        isDisabled={isDisabled}
      >
        <div className="flex text-white items-center">
          <Plus />
          <Text className="normal-case ml-2.5 text-lg">Add</Text>
        </div>
      </Button>
      <Popover className="w-[156px] py-2" offset={2}>
        <button
          className="flex items-center text-lg font-regular h-9 px-2.5 py-4 w-full hover:bg-gray-100 "
          onClick={() => onPresentationClick()}
        >
          Presentation
        </button>
        <button
          className="flex items-center text-lg font-regular h-9 px-2.5 py-4 w-full hover:bg-gray-100 "
          onClick={() => onPlaylistClick()}
        >
          Playlist
        </button>
      </Popover>
    </DialogTrigger>
  );
};

export default LibraryPageActionButton;
